module.exports = __webpack_public_path__ + "static/media/20_judgement.5dbfc791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20_judgement.png
// module id = 83
// module chunks = 0